// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../../common/Components/Alert.bs.js");
let React = require("react");
let V4 = require("uuid/v4");
let DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ConfirmDialog = require("../../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let MyClientsWidgetDeleteDialog_clientV5_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_clientV5_graphql.bs.js");
let MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.bs.js");
let MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.bs.js");
let MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.bs.js");
let MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql = require("../../../__generated__/MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.bs.js");

let convertVariables = MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.Internal.convertVariables;

let convertResponse = MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, MyClientsWidgetDeleteDialog_mutations_deleteForSalePropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let DeleteForSalePropertyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertVariables$1 = MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.Internal.convertVariables;

let convertResponse$1 = MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let DeleteRentalPropertyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

let convertVariables$2 = MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.Internal.convertVariables;

let convertResponse$2 = MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$2 = RescriptRelay_Mutation.commitMutation(convertVariables$2, MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, MyClientsWidgetDeleteDialog_mutations_deleteBuyerNeedMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let DeleteBuyerNeedMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$2,
  use: use$2
};

let convertVariables$3 = MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.Internal.convertVariables;

let convertResponse$3 = MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$3 = MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$3 = RescriptRelay_Mutation.commitMutation(convertVariables$3, MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

let use$3 = RescriptRelay_Mutation.useMutation(convertVariables$3, MyClientsWidgetDeleteDialog_mutations_deleteRentalNeedMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

let DeleteRentalNeedMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$3,
  convertResponse: convertResponse$3,
  convertWrapRawResponse: convertWrapRawResponse$3,
  commitMutation: commitMutation$3,
  use: use$3
};

let Mutations = {
  DeleteForSalePropertyMutation: DeleteForSalePropertyMutation,
  DeleteRentalPropertyMutation: DeleteRentalPropertyMutation,
  DeleteBuyerNeedMutation: DeleteBuyerNeedMutation,
  DeleteRentalNeedMutation: DeleteRentalNeedMutation
};

let convertFragment = MyClientsWidgetDeleteDialog_clientV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetDeleteDialog_clientV5_graphql.node, convertFragment, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetDeleteDialog_clientV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetDeleteDialog_clientV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetDeleteDialog_clientV5_graphql.node, convertFragment, fRef);
}

let ClientFragment_buyerNeedMatchingType_decode = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.buyerNeedMatchingType_decode;

let ClientFragment_buyerNeedMatchingType_fromString = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.buyerNeedMatchingType_fromString;

let ClientFragment_forSalePropertyMatchingType_decode = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.forSalePropertyMatchingType_decode;

let ClientFragment_forSalePropertyMatchingType_fromString = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.forSalePropertyMatchingType_fromString;

let ClientFragment_rentalNeedMatchingType_decode = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.rentalNeedMatchingType_decode;

let ClientFragment_rentalNeedMatchingType_fromString = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.rentalNeedMatchingType_fromString;

let ClientFragment_rentalPropertyMatchingType_decode = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.rentalPropertyMatchingType_decode;

let ClientFragment_rentalPropertyMatchingType_fromString = MyClientsWidgetDeleteDialog_clientV5_graphql.Utils.rentalPropertyMatchingType_fromString;

let ClientFragment = {
  buyerNeedMatchingType_decode: ClientFragment_buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: ClientFragment_buyerNeedMatchingType_fromString,
  forSalePropertyMatchingType_decode: ClientFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: ClientFragment_forSalePropertyMatchingType_fromString,
  rentalNeedMatchingType_decode: ClientFragment_rentalNeedMatchingType_decode,
  rentalNeedMatchingType_fromString: ClientFragment_rentalNeedMatchingType_fromString,
  rentalPropertyMatchingType_decode: ClientFragment_rentalPropertyMatchingType_decode,
  rentalPropertyMatchingType_fromString: ClientFragment_rentalPropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$4,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetDeleteDialog(props) {
  let onSuccess_ = props.onSuccess;
  let onCancel = props.onCancel;
  let isOpen = props.isOpen;
  let client = RescriptRelay_Fragment.useFragment(MyClientsWidgetDeleteDialog_clientV5_graphql.node, convertFragment, props.client);
  let match;
  switch (client.__typename) {
    case "Buyer" :
      match = [
        "Buyer",
        "buyer need",
        client.canDelete
      ];
      break;
    case "Landlord" :
      match = [
        "Landlord",
        "property",
        client.canDelete
      ];
      break;
    case "Renter" :
      match = [
        "Renter",
        "rental need",
        client.canDelete
      ];
      break;
    case "Seller" :
      match = [
        "Seller",
        "property",
        client.canDelete
      ];
      break;
    case "__unselected" :
      match = UnselectedUnionMemberError.raise(`Unselected  ` + client._0);
      break;
  }
  let canDelete = match[2];
  let entityTypeLabel = match[1];
  let clientTypeLabel = match[0];
  let visibility;
  switch (client.__typename) {
    case "Buyer" :
      let tmp = client.buyerNeed.matchingType;
      visibility = tmp === "BROADCAST" ? "Public" : "Private";
      break;
    case "Landlord" :
      let tmp$1 = client.property.rentalPropertyMatchingType;
      visibility = tmp$1 === "BROADCAST" ? "Public" : "Private";
      break;
    case "Renter" :
      let tmp$2 = client.rentalNeed.matchingType;
      visibility = tmp$2 === "BROADCAST" ? "Public" : "Private";
      break;
    case "Seller" :
      let tmp$3 = client.forSaleProperty.forSalePropertyMatchingType;
      visibility = tmp$3 === "BROADCAST" ? "Public" : "Private";
      break;
    case "__unselected" :
      visibility = "Private";
      break;
  }
  let match$1 = React.useState(() => "Idle");
  let setState = match$1[1];
  let state = match$1[0];
  let match$2 = use();
  let deleteForSaleProperty = match$2[0];
  let match$3 = use$1();
  let deleteRentalProperty = match$3[0];
  let match$4 = use$2();
  let deleteBuyerNeed = match$4[0];
  let match$5 = use$3();
  let deleteRentalNeed = match$5[0];
  let match$6 = SystemMessages.useSystemMessages();
  let addMessage = match$6.addMessage;
  let onSuccess = () => {
    addMessage(SystemMessages.Message.make(V4(), "info", "The client was deleted.", 5000, undefined, undefined));
    onSuccess_();
  };
  let connections = Stdlib_Option.getOr(Stdlib_Option.map(props.connectionId, id => [id]), []);
  let onConfirm = () => {
    setState(param => "Submitting");
    switch (client.__typename) {
      case "Buyer" :
        deleteBuyerNeed({
          connections: connections,
          input: {
            id: client.buyerNeed.id
          }
        }, undefined, undefined, undefined, (response, param) => {
          let match = response.deleteBuyerNeed;
          if (match !== undefined) {
            if (match.__typename === "BuyerNeedDeleted") {
              return onSuccess();
            } else {
              return setState(param => "Error");
            }
          } else {
            return setState(param => "Error");
          }
        }, param => setState(param => "Error"), undefined);
        break;
      case "Landlord" :
        deleteRentalProperty({
          connections: connections,
          input: {
            id: client.property.id
          }
        }, undefined, undefined, undefined, (response, param) => {
          let match = response.deleteRentalProperty;
          if (match !== undefined) {
            if (match.__typename === "RentalPropertyDeleted") {
              return onSuccess();
            } else {
              return setState(param => "Error");
            }
          } else {
            return setState(param => "Error");
          }
        }, param => setState(param => "Error"), undefined);
        break;
      case "Renter" :
        deleteRentalNeed({
          connections: connections,
          input: {
            id: client.rentalNeed.id
          }
        }, undefined, undefined, undefined, (response, param) => {
          let match = response.deleteRentalNeed;
          if (match !== undefined) {
            if (match.__typename === "RentalNeedDeleted") {
              return onSuccess();
            } else {
              return setState(param => "Error");
            }
          } else {
            return setState(param => "Error");
          }
        }, param => setState(param => "Error"), undefined);
        break;
      case "Seller" :
        deleteForSaleProperty({
          connections: connections,
          input: {
            id: client.forSaleProperty.id
          }
        }, undefined, undefined, undefined, (response, param) => {
          let match = response.deleteForSaleProperty;
          if (match !== undefined) {
            if (match.__typename === "ForSalePropertyDeleted") {
              return onSuccess();
            } else {
              return setState(param => "Error");
            }
          } else {
            return setState(param => "Error");
          }
        }, param => setState(param => "Error"), undefined);
        break;
      case "__unselected" :
        UnselectedUnionMemberError.raise(`Unselected client ` + client._0);
        break;
    }
  };
  if (canDelete !== undefined && !canDelete) {
    return JsxRuntime.jsx(DialogV5.make, {
      title: `Unable to delete ` + clientTypeLabel,
      isOpen: isOpen,
      ariaLabel: `Unable to delete ` + clientTypeLabel,
      onDismiss: onCancel,
      children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("p", {
            children: "It's not possible to delete a client who has been invited or registered for client access.",
            className: "leading-6"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              onClick: param => onCancel(),
              children: "OK"
            }),
            className: "flex gap-4 mt-4 justify-end"
          })
        ]
      })
    });
  }
  let tmp$4;
  switch (state) {
    case "Idle" :
    case "Submitting" :
      tmp$4 = null;
      break;
    case "Error" :
      tmp$4 = JsxRuntime.jsx(Alert.$$Error.make, {
        title: "An error occurred while deleting the client. Please try again."
      });
      break;
  }
  return JsxRuntime.jsx(ConfirmDialog.make, {
    title: `Delete ` + clientTypeLabel + `?`,
    ariaLabel: `Confirm Delete ` + clientTypeLabel,
    body: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("p", {
          children: visibility === "Public" ? "Other agents can no longer find your client's " + entityTypeLabel + " nor see any matches they might have. Conversations that have already been started can continue." : "Other agents can no longer see any matches they might have with your client's " + entityTypeLabel + ". Conversations that have already been started can continue.",
          className: "leading-6"
        }),
        JsxRuntime.jsx("br", {}),
        JsxRuntime.jsx("p", {
          children: "THIS CANNOT BE UNDONE",
          className: "font-bold"
        }),
        tmp$4
      ],
      className: "space-y-2"
    }),
    isOpen: isOpen,
    onCancel: onCancel,
    cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      onClick: param => onCancel(),
      children: `No, Keep ` + clientTypeLabel
    }),
    confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
      onClick: param => onConfirm(),
      disabled: state === "Submitting",
      children: `Yes, Delete ` + clientTypeLabel
    })
  });
}

let make = MyClientsWidgetDeleteDialog;

exports.Mutations = Mutations;
exports.ClientFragment = ClientFragment;
exports.make = make;
/* commitMutation Not a pure module */
